import React from "react";
import './components.css'
import {Button} from '@mui/material'

export default ({onButtonClicked})=>{
 

    return (
        // <button onClick={onButtonClicked}
        //     id="genQRBtn"
        // >
        //     Generate FPS QR Code
        // </button>

        
        <Button onClick={onButtonClicked}
            id="genQRBtn"
            color="primary"
            variant="contained"
        >
            Generate FPS QR Code
        </Button>
    )
}